<span #container>
  <ng-content></ng-content>
</span>
